import React from 'react'
import MenuDrawerUI from 'components/MenuDrawer'
import { useUnreadNotificationsCount } from 'contexts/UnreadNotifications'

export const MenuDrawer = () => {
  const unreadNotificationCount = useUnreadNotificationsCount()
  return <MenuDrawerUI unreadNotificationCount={unreadNotificationCount} />
}

export default MenuDrawer
